import { useEffect } from 'react';
import classes from './SkillLmProjectSelect.module.css';

const SkillLmProjectSelect = ({ id, label, value, onChange, disabled }) => {
  const projects = window.config?.skillLmProjects || [];
  const firstId = projects[0]?.id ?? '';
  const resolvedValue = value || firstId;

  useEffect(() => {
    if (!value && firstId) onChange(firstId);
  }, [value, firstId, onChange]);

  return (
    <div className={classes.Field}>
      <label className={classes.Label} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className={classes.Select}
        value={resolvedValue}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      >
        {projects.map(project =>
          <option key={project.id} value={project.id}>
            {project.name || project.id}
          </option>
        )}
      </select>
    </div>
  );
};

export default SkillLmProjectSelect;
